export default __webpack_public_path__ + "images/F4.bbc4191.png";